/**
 * Фразы-реакции для переменных наград. Выбираются детерминированно
 * по hash(op.id), так что одна и та же операция всегда даёт одну фразу.
 */

export const CRIT_PHRASES = [
  'Джекпот внимательности',
  'Удача любит записывающих',
  'Редкая запись!',
  'Монетный дождь',
  'Критическая фиксация',
  'Бухгалтерия аплодирует',
  'Бонус за дисциплину',
  'Счастливая запись',
] as const;

export const INCOME_PHRASES = [
  'Кошелёк потяжелел',
  'Заработано. Так держать',
  'Большой день — приход!',
  'Касса пополнена',
  'Деньги нашли тебя',
  'Доход зафиксирован. Красиво',
] as const;

export const DAILY_LOGIN_PHRASES = [
  'Первый вход дня — монетка в семейную казну',
  'Кто-то заглянул — казна пополнилась',
  'День открыт, монеты капнули',
  'Кто первый вошёл, тот принёс монетку',
] as const;
